<div class="wrapper">
	<div [ngClass]="{'no-display': state ==='collapsed' }" id="dropdown-container" [@displayAnim]="state">
		<ul id="container-list">
			<li (click)="gotoOrderInfo()">
				<div class="menu-item-content">
					{{ 'ORDERS' | translate }}
				</div>
			</li>

			<li (click)="toggleGeneralInfoMenu()">
				<div class="menu-item-content">
					{{'OPTIONS-DROPDOWN.GENERAL-INFO' | translate}}
				</div>
				<i class="fa-light fa-angle-right"></i>
				<ul id="info-list" class="second-level-menu" [ngStyle]="{'display':currentMenu !== 'info' ? 'none' : 'inherit' }">
					<li (click)="showDeliveryModal()">
						<div class="menu-item-content">
							{{ 'OPTIONS-DROPDOWN.PRODUCTION-TIMES' | translate }}
						</div>
					</li>

					<li (click)="showLegalModal()">
						<div class="menu-item-content">
							{{ 'OPTIONS-DROPDOWN.LEGAL' | translate }}
						</div>
					</li>

					<li (click)="showServicePointInfoModal()">
						<div class="menu-item-content">
							{{ 'OPTIONS-DROPDOWN.SERVICE-POINT-INFO' | translate }}
						</div>
					</li>
				</ul>
			</li>

			@if (doShowTermsMenuItem()) {
			<li (click)="showTermsModal()">
				<div class="menu-item-content">
					{{ 'OPTIONS-DROPDOWN.TERMSANDCONDITIONS' | translate}}
					@if (showTermsNotification) {
					<div class="bullet">&nbsp;</div>
					}
				</div>
			</li>
			}

			<li (click)="showEnduserDisplayModal()">
				<div class="menu-item-content">
					{{'HOME.ENDUSERDISPLAY.READMORE2' | translate}}
				</div>
			</li>

			@if (showFileMakerAppsMenuItem()) {
			<li (click)="showFileMakerApps()">
				<div class="menu-item-content">
					{{'OPTIONS-DROPDOWN.FILEMAKERAPPS' | translate}}
				</div>
			</li>
			}

			<li (click)="ShowLanguages()">
				<div class="menu-item-content">
					{{'OPTIONS-DROPDOWN.LANGUAGE' | translate:{ language: 'OPTIONS-DROPDOWN.LANGUAGES.' +
					currentLanguage | translate } }}
				</div>
				<i class="fa-light fa-angle-right"></i>
				<ul id="language-list" class="second-level-menu" [ngStyle]="{'display':currentMenu !== 'languages' ? 'none' : 'inherit' }">
					@for (language of availableLanguages; track $index) {
					<li [attr.lang]="language" (click)="changeLanguage(language, $event)" [ngClass]="{'selected': language === currentLanguage}">
						<div class="menu-item-content">
							@if (language === currentLanguage) {
							<i class="fa-light fa-check"></i>
							}
							{{'OPTIONS-DROPDOWN.LANGUAGES.' + language | translate}}
						</div>
					</li>
					}
				</ul>
			</li>

			@if (prefsReady && appState.priceModuleEnabled.getValue() && currentPriceSetting) {
			<li (click)="togglePriceSettingsMenu()">
				<div class="menu-item-content">
					{{'OPTIONS-DROPDOWN.PRICE' | translate }}: {{ (currentPriceSetting.PriceSettingDescription || 'DEFAULT_DESCRIPTION') | translate}}
				</div>
				<i class="fa-light fa-angle-right"></i>
				<ul id="price-settings-list" class="second-level-menu" [ngStyle]="{'display':currentMenu !== 'price' ? 'none' : 'inherit' }">
					@for (priceSetting of priceSettings; track priceSetting) {
					<li (click)="changePriceSetting(priceSetting, $event)" [ngClass]="{'selected': priceSetting?.PriceSetting === currentPriceSetting.PriceSetting}">
						<div class="menu-item-content">
							@if (priceSetting?.PriceSetting === currentPriceSetting.PriceSetting) {
							<i class="fa-light fa-check"></i>
							}
							@if (priceSetting && priceSetting.PriceSettingDescription) {
							{{priceSetting.PriceSettingDescription | translate}}
							}
						</div>
					</li>
					}
				</ul>
			</li>
			}

			<li (click)="toggleConfigurationStringState()">
				<div class="menu-item-content">
					@if (userPreferencesStore.configurationStringActive()) {
					{{ 'OPTIONS-DROPDOWN.CONFIGURATION-STRING-ACTIVE' | translate }}
					}
					@else {
					{{ 'OPTIONS-DROPDOWN.CONFIGURATION-STRING-INACTIVE' | translate }}
					}
				</div>
			</li>

			<li (click)="showSupportModal()">
				<div class="menu-item-content">
					{{ 'OPTIONS-DROPDOWN.SUPPORT' | translate }}
				</div>
			</li>

			@if (showAdminModeToggle) {
			<li (click)="goToServiceManager()">
				<div class="menu-item-content">
					{{ 'OPTIONS-DROPDOWN.SERVICE-MANAGER' | translate }}
				</div>
			</li>

			<li (click)="toggleAdminMode()">
				<div class="menu-item-content">
					{{adminModelEnabled ? 'disable admin mode' : 'enable admin mode'}}
				</div>
			</li>
			}

			<li (click)="showLogOutModal()">
				<div class="menu-item-content">
					{{ 'HOMEFUNCTIONS.LOGOUT' | translate }}
				</div>
			</li>
		</ul>
	</div>
</div>